export default __webpack_public_path__ + "static/media/PR-Card-port-1.9f2bdab8.jpg";